<template>
  <div class="cardetails full-height linear-main3">
    <x-header
      :transparent="true"
      :white="true"
      @click-left="$router.push({path:'/allOrder?findType=1'})"
    >
      <span class="font12">{{ $t('F001', '订单号') }}：{{ details.orderNo }}&nbsp;{{ details.tripType|tripType }}</span>
    </x-header>
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="box">
          <div class="pad-b-20">
            <div class="head white font14">
              <div class="font22 font-md">
                {{ details.orderStatusName }}
                <span
                  v-if="blztList.length"
                  @click="blztShow = true"
                  class="font12"
                  style="text-decoration: underline;"
                >
                  查看用车进度
                </span>
              </div>
              <div v-show="details.realOrderStatus==1">
                {{ $t('C417', '特别提示') }}！
              </div>
              <!-- <div v-show="details.realOrderStatus==1">
              您本次预订占座未成功，需要向航空公司申请座位，请等待服务商回复。如有疑问，请致电服务商咨询!
              </div> -->
              <!-- <div v-show="details.realOrderStatus!=1&&!details.isShowApproval">
              {{ $t('H204','订单已成功提交') }}！
              </div> -->
              <div>
                {{ $t('F002', '预订时间') }}：{{ details.bookDate }}
              </div>
              <div>
                {{ $t('F003', '预订人') }}：{{ details.bookerName }}
              </div>

              <van-notice-bar
                v-if="details.qxyy"
                class="clbz-bar"
                mode="link"
                :scrollable="false"
                @click="$dialog({title: $t('H114','取消原因'), message: details.qxyy})"
              >
                <span>{{ $t('H114', '取消原因') }}：{{ details.qxyy }}</span>
              </van-notice-bar>
            </div>
            <div
              class="planeBox"
              v-show="order.priceFlag==1"
            >
              <div class="tips">
                当前预订舱位价格发生变化，系统已自动修改订单，实际价格以订单价格为准!
              </div>
            </div>
            <div class="planeBox">
              <van-card :thumb="details.coverUrl">
                <div slot="title">
                  <span class="font-md">{{ details.vehicleTypeName }}</span>&nbsp;
                  <van-tag type="warning">
                    {{ details.orderTypeName }}
                  </van-tag>
                  &nbsp;
                  <span v-if="details.priceFromName">{{ details.priceFromName }}</span>
                  <span v-else>智通天行</span>
                </div>
                <div
                  slot="desc"
                  class="pad-tb-5"
                >
                  <van-tag
                    plain
                    type="danger"
                    v-show="details.luggageNo"
                  >
                    <ld-icon class="iconfont iconchangyongicon-" />
                    ×{{ details.luggageNo }}
                  </van-tag>&nbsp;
                  <van-tag
                    plain
                    type="danger"
                    v-show="details.personNo"
                  >
                    <ld-icon class="iconfont icongerentouxiang_o" />
                    ×{{ details.personNo }}
                  </van-tag>
                  &nbsp;
                  <span
                    class="main-color"
                    @click="baggageExplainShow = true"
                  >
                    {{ $t('J244', '行李说明') }}
                    <van-icon
                      name="arrow"
                      class="vertical-middle"
                    />
                  </span>

                  <div class="gray pad-tb-5">
                    {{ details.vehiclesDesc }}
                  </div>
                </div>
                <div
                  slot="footer"
                  class="van-hairline--top van-clearfix gray pad-tb-5"
                >
                  <van-row
                    type="flex"
                    align="center"
                    justify="space-between"
                    class="p-t-15"
                  >
                    <van-col
                      span="19"
                      class="text-left"
                    >
                      <van-tag
                        plain
                        type="warning"
                      >
                        退改
                      </van-tag>
                      {{ $t('J238', '用车服务开始前，订单可免费取消') }}
                    </van-col>
                    <!-- 没有绑定事件，暂时先注释掉 2023年4月4日 14:10:54
                    <van-col
                      span="5"
                      class="text-left main-color"
                    >
                      {{ $t('J239','用车规则') }}
                      <van-icon
                        name="arrow"
                        class="vertical-middle"
                      />
                    </van-col>-->
                  </van-row>
                </div>
              </van-card>
            </div>
            <div class="planeBox">
              <van-cell-group>
                <van-cell>
                  <van-row>
                    <van-col span="5">
                      {{ $t('J009', '用车时间') }}
                    </van-col>
                    <van-col
                      span="19"
                      class="gray"
                    >
                      {{ details.startTime }} &nbsp;{{ details.startTime|week }}
                    </van-col>
                  </van-row>
                </van-cell>

                <van-field
                  :label="$t('J023','上车地点')"
                  v-if="details.orderType==1"
                >
                  <span slot="input">{{ details.scdd }}</span>
                </van-field>
                <div v-else>
                  <van-cell>
                    <van-row
                      type="flex"
                      align="center"
                    >
                      <van-col span="5">
                        <div>{{ $t('J023', '上车地点') }}</div>
                      </van-col>
                      <van-col span="2">
                        <div>
                          <img
                            src="~Assets/images/car/start.png"
                            alt="上车地点"
                            width="20"
                            class="vertical-middle"
                          >
                        </div>
                      </van-col>
                      <van-col span="17">
                        <div>{{ details.scddPoi }}</div>
                        <div class="font12 gray">
                          {{ details.scdd ? (details.scdd.split('|')[1]) : '' }}
                        </div>
                      </van-col>
                    </van-row>
                  </van-cell>
                  <van-cell>
                    <van-row
                      type="flex"
                      align="center"
                    >
                      <van-col span="5">
                        <div>{{ $t('J024', '下车地点') }}</div>
                      </van-col>
                      <van-col span="2">
                        <div>
                          <img
                            src="~Assets/images/car/end.png"
                            alt="下车地点"
                            width="21"
                            class="vertical-middle"
                          >
                        </div>
                      </van-col>
                      <van-col span="17">
                        <div> {{ details.xcddPoi }}</div>
                        <div class="font12 gray">
                          {{ details.xcdd ? (details.xcdd.split('|')[1]) : '' }}
                        </div>
                      </van-col>
                    </van-row>
                  </van-cell>
                </div>

                <van-field
                  label="包车天数"
                  v-if="details.orderType==1"
                >
                  <span slot="input">{{ details.useDays }}天</span>
                </van-field>
                <van-cell>
                  <van-row>
                    <van-col span="5">
                      {{ $t('Car', '用车人') }}
                    </van-col>
                    <van-col
                      span="19"
                      class="gray"
                    >
                      {{ details.empName }}
                      {{ details.phoneNumber }}
                    </van-col>
                  </van-row>
                </van-cell>
              </van-cell-group>
            </div>

            <!-- 送机 -->
            <div class="planeBox">
              <van-cell
                class="black"
                v-if="details.orderType==5"
              >
                <template #icon>
                  <img
                    src="~Assets/images/car/flightNo.png"
                    alt="."
                    class="vertical-bottom"
                    style="width:26px;height:26px;"
                  >
                </template>
                <template #title>
                  {{ details.departAirportName }}
                </template>
                <template #label>
                  {{ details.flightno }} {{ details.departTime }} 出发
                </template>
              </van-cell>
            </div>

            <!-- 司机信息 -->
            <div
              v-if="details.licenseNumber"
              class="planeBox"
            >
              <van-cell
                :title="$t('Driver','司机信息')"
                :border="false"
              />
              <van-cell-group>
                <van-field
                  :label="$t('J241','司机姓名')"
                  :readonly="true"
                  v-model="details.driver"
                />
                <van-field
                  :label="$t('J242','司机手机号')"
                  :readonly="true"
                  v-model="details.driverTel"
                />
                <van-field
                  :label="$t('J306','车牌号')"
                  :readonly="true"
                  v-model="details.licenseNumber"
                />
                <van-field
                  :label="$t('J240','车辆信息')"
                  :readonly="true"
                  v-model="details.vehiclesDescColor"
                />
                <van-field
                  :label="$t('J243','司机备注')"
                  :readonly="true"
                  v-model="details.vehiclesRemark"
                />
              </van-cell-group>
            </div>

            <div v-if="details.tripType==1">
              <div class="planeBox">
                <!-- 差旅信息 -->
                <travel-info
                  ref="travelinfo"
                  :travel-data="details"
                  :details="true"
                />
              </div>
            </div>

            <van-row
              class="sc bg-white"
              @click="unionOrder"
              v-show="details.unionOrderNo"
            >
              <van-col
                class="text-center"
                span="3"
              >
                关联<br>订单
              </van-col>
              <van-col span="2" />
              <van-col span="17">
                <div>机票</div>
                <div>订单编号：{{ details.unionOrderNo }}</div>
              </van-col>
              <van-col>
                <van-icon
                  class="right-icon"
                  name="arrow"
                />
              </van-col>
            </van-row>
          </div>
        </div>
      </mescroll-vue>
    </div>

    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
      class="bg-white shadow"
    >
      <van-row
        type="flex"
        align="center"
        class="full-width"
        justify="space-between"
        gutter="8"
      >
        <van-col span="1" />
        <van-col span="11">
          <span class="font12 red">&yen; </span>
          <span class="font22 red"> {{ details.totalAmount }}</span>
          <span
            v-show="!details.hideYg"
            class="font10 gray"
          >(预估)</span>
          &nbsp;
          <span
            class="font12 text-left"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006', '明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </span>
        </van-col>
        <van-col
          span="6"
          class="pad-5"
        >
          <ld-button
            defaults
            size="md"
            v-if="details.showCancelButton==1"
            @click.native="cancel()"
          >
            {{ $t('B008', '取消') }}
          </ld-button>
        </van-col>
        <van-col
          span="6"
          class="pad-5"
        >
          <ld-button
            main
            size="md"
            v-if="details.showPayBtn==1"
            @click.native="pay"
          >
            {{ $t('B014', '支付') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!--支付  -->
    <!-- <ld-pay
      ref="pay"
      order-type="11018"
      :order-id="orderId"
    /> -->

    <!-- 原因  -->
    <cancel-rason
      ref="cancelRason"
      @selected="chooseRason"
    />

    <!-- 行李说明 -->
    <BaggageExplain
      :value="details"
      :visibility.sync="baggageExplainShow"
      element=".cardetails"
      height="80%"
    />

    <!-- 用车进度 -->
    <van-popup
      v-model="blztShow"
      position="bottom"
      round
      lock-scroll
      close-on-popstate
      class="CarProgress"
      :style="{
        width: '100%',
        maxHeight: '80%'
      }"
    >
      <ld-header
        :title="$t('J245', '用车进度')"
        @click-left="blztShow = false"
      />
      <div style="padding: 20px;">
        <van-steps
          class="bg-lightGray round-md shadow"
          direction="vertical"
          :active="0"
        >
          <van-step
            v-for="(blzt, i) in blztList"
            :key="i"
          >
            <h3 style="margin: 0;">
              {{ blzt.pcztName }}
            </h3>
            <p style="margin-top: 8px;">
              {{ blzt.createdate }}
            </p>
          </van-step>
        </van-steps>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Card, CellGroup, Cell, Picker, Popup, Tag, Field, NoticeBar, Step, Steps} from 'vant'
import BaggageExplain from './components/BaggageExplain'
// import ldPay from 'Components/ldPay/index.vue'

import XHeader from 'Common/ldHeader'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import travelInfo from 'Components/travelInfo'
import MescrollVue from 'mescroll.js/mescroll.vue'
import cancelRason from './components/cancelRason.vue'

export default {
  name: 'Cardetails',
  components: {
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [NoticeBar.name]: NoticeBar,
    [Step.name]: Step,
    [Steps.name]: Steps,
    // ldPay,
    XHeader,
    ldButton,
    ldTabbar,
    travelInfo,
    MescrollVue,
    cancelRason,
    BaggageExplain
  },
  data() {
    return {
      down: {use: false},
      info: {},
      flights: [],
      travelData: {
        projectName: '',
        costCenterName: '',
        ccsqdNo: '',
        reasonCode: '',
        ccsqdRemark: '',
        reasonDesc: '',
      },
      details: {
        orderPsgBeanList: [],
      },
      blztList: [],
      order: {},
      baggageExplainShow: false,
      blztShow: false
    }
  },
  computed: {
    orderId() {
      return this.$route.query.orderId
    },
    priceList() {
      let rt = []
      rt.push({name: '车费', price: this.details.useVehicleFee})

      if (this.details.xsjgsmList) {
        this.details.xsjgsmList.forEach(xsjgsm => {
          rt.push({name: xsjgsm.label, price: xsjgsm.value, style: {fontSize: '12px', color: '#999'}, hideYen: true})
        })
      }

      rt.push(
        {name: '服务费', price: this.details.serviceFee},
        {name: '总价', price: this.details.totalAmount, amount: '', unit: '', class: 'font-bold'}
      )

      return rt
    },
  },
  activated() {
    if (this.orderId) {
      this.getDetail()
    }
  },
  created() {
    if (this.orderId) {
      this.getDetail()
    }
  },
  methods: {
    getDetail() {
      this.$api['carOrder/orderDetail']({
        orderId: this.orderId,
      })
        .then((res) => {
          let cache = res.data || {}

          if (cache.xsjgsm) {
            cache.xsjgsmList = cache.xsjgsm.split('#').map(val => {
              val = val.split(':')
              return {label: val[0], value: val[1]}
            })
          }
          if (cache.vehiclesDesc) cache.vehiclesDescColor = `${cache.vehiclesDesc} - ${cache.vehiclesColor}`
          if (['6', '7', '8', '9'].indexOf(cache.orderStatus) > -1) {
            cache.hideYg = true // 不展示预估
          }
          this.details = cache

          this.getBlztList()
        })
        .catch((res) => {
          this.$toast(res.errMsg)
        })
    },
    getBlztList() {
      this.$api['carOrder/blztList']({
        orderId: this.orderId,
      })
        .then((res) => {
          let cache = res.data || []
          this.blztList = cache.reverse()
        })
        .catch((res) => {
          this.$toast(res.errMsg)
        })
    },
    cancel() {
      this.$api['carOrder/getCancelFee']({
        orderId: this.orderId,
      }).then((res) => {
        let cache = res.data || {}
        if (cache.khFine) {
          this.$dialog.confirm({
            title: '提示',
            message: `取消订单会产生罚金￥${cache.khFine}，是否继续取消订单？`,
          }).then(() => {
            this.toggle('cancelRason')
          }).catch(() => {
            // on cancel
          })
        } else {
          this.$dialog.confirm({
            title: '提示',
            message: '是否取消订单',
          }).then(() => {
            this.toggle('cancelRason')
          }).catch(() => {
            // on cancel
          })
        }
      }).catch(res => {
        if (res.errCode === '1801') {
          this.$dialog.confirm({
            title: '提示',
            message: '当前状态下取消用车罚金暂不确定，具体以取消后的为准。是否继续取消？',
          }).then(() => {
            this.toggle('cancelRason')
          }).catch(() => {
            // on cancel
          })
        }
      })
    },
    chooseRason(info) {
      if (info && info.value) {
        this.showReason = false
        this.$api['carOrder/orderCancel']({
          orderId: this.orderId,
          qxbh: info.value, // 取消原因id
          qxyy: info.text, // 取消原因描述
          sfqx: 1, // 是否取消
        }).then(() => {
          this.getDetail()
        })
      }
    },
    unionOrder() {
      this.$router.push({
        path: '/tk/tkOrderDetails',
        query: {text: '我是阿格斯之怂'},
      })
    },
    onPullingDown() {
      this.getDetail()
    },
    pay() {
      this.$router.push({
        path: '/pay/payment',
        query: {orderType: '11018', orderId: this.orderId},
      })
    },
    toggle(name) {
      this.$refs[name].toggle()
    },
  },
  filters: {
    tripType(val) {
      return val == 1 ? '公' : '私'
    },
  },
}
</script>

<style lang="less" scoped>
@import "~Assets/styles/business.less";

.cardetails {
  font-size: @font-size-14;

  .pad-5 {
    padding: 5px;
  }

  .van-card {
    background-color: @color-background-white;
  }

  .van-card__content {
    min-height: auto;
  }

  .van-card__thumb {
    height: auto;
  }

  .sc {
    padding: 0.2rem 0.32rem;
  }

  .right-icon {
    margin-left: 5px;
    color: #969799;
    min-width: 1em;
    height: 42px;
    font-size: @font-size-16;
    line-height: 42px;
  }

  .box {
    padding: 0 0.16rem;

    .head {
      padding: 0.3rem 0.2rem 0.4rem;
    }
  }

  .wrapper {
    position: relative;
    height: calc(100% - 96px);
    overflow: hidden;
  }

  .planeBox {
    padding-bottom: 5px;
  }

  .pad-b-20 {
    padding-bottom: 20px;
  }

  .pad-tb-5 {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
</style>
